import {
    documentToReactComponents,
    Options,
} from '@contentful/rich-text-react-renderer';
import { BLOCKS, Document, Node } from '@contentful/rich-text-types';
import { Box } from '@zoopla-eng/zds-components/box';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import { CONTENTFUL_RICH_TEXT_OPTIONS } from '@zoopla/cms/contentful-render-options';
import { Children } from 'react';
import { ReactNode } from 'react';
import { smallPrint } from './SmallPrint.styles.css';

// Here we have to override how we render paragraphs to ensure a smaller font.
// Note the fontGroup.spoon on the <p>
const SMALLPRINT_RENDER_OPTIONS: Options = {
    ...CONTENTFUL_RICH_TEXT_OPTIONS,
    renderNode: {
        ...CONTENTFUL_RICH_TEXT_OPTIONS.renderNode,
        [BLOCKS.PARAGRAPH]: (_node: Node, children: React.ReactNode) => {
            const isEmptyChildren = children?.toString().trim() === '';
            if (isEmptyChildren) return null;

            return <p className={fontGroups.spoon}>{children}</p>;
        },
    },
};

interface SmallPrintProps {
    content: Document;
}

function SmallPrint({ content }: SmallPrintProps) {
    const renderedContent: ReactNode = documentToReactComponents(
        content,
        SMALLPRINT_RENDER_OPTIONS
    );

    if (Children.toArray(renderedContent).length === 0) {
        return null;
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            rowGap="S200"
            className={smallPrint}
        >
            {renderedContent}
        </Box>
    );
}

export default SmallPrint;
